import { createSlice } from '@reduxjs/toolkit'

interface UiState {
  isSidebarOpen: boolean
  isTrialDialogOpen: boolean
  isOnboardDialogOpen: boolean
}

const initialState: UiState = {
  isSidebarOpen: false,
  isTrialDialogOpen: false,
  isOnboardDialogOpen: false
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen
    },
    closeSidebar(state) {
      state.isSidebarOpen = false
    },
    openSidebar(state) {
      state.isSidebarOpen = true
    },
    openTrialDialog(state) {
      state.isTrialDialogOpen = true
    },
    closeTrialDialog(state) {
      state.isTrialDialogOpen = false
    },
    openOnboardDialog(state) {
      state.isOnboardDialogOpen = true
    },
    closeOnboardDialog(state) {
      state.isOnboardDialogOpen = false
    }
  }
})

export const {
  toggleSidebar,
  closeSidebar,
  openSidebar,
  openTrialDialog,
  closeTrialDialog,
  openOnboardDialog,
  closeOnboardDialog
} = uiSlice.actions
export default uiSlice.reducer
